import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@mui/styles';
import { TextField, Typography, Chip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

const useStyles = makeStyles(theme => ({
  listbox: {
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
}));

export default function SimpleAutoCompleteMultipleWithColorStatus(props) {

  const { label, options, stateName, changeSelect, selected, required, disabled = false } = props;

  const defaultvalue = [];
  const classes = useStyles();

  const [opt, setOption] = React.useState(selected ? selected : defaultvalue);

  React.useEffect(() => {
    setOption(selected ? selected : defaultvalue);
  }, [selected]);

  const handleChange = (event, value) => {
    if (value == null) {
      value = [];
    }

    setOption(value);
    changeSelect(stateName, value);
  };

  return (
    <Autocomplete
      disabled={disabled}
      multiple
      disableCloseOnSelect
      id="combo-box-with-color-status"
      options={options || []}
      classes={classes}
      value={opt}
      getOptionLabel={option => (option.title ? option.title : option.name)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={handleChange}
      style={{ fullWidth: true }}
      renderOption={(liProps, option) => (
        <li {...liProps} key={option.id} style={{ display: 'flex', alignItems: 'center' }}>
          <div className='m-item-color' style={{ backgroundColor: option.colorhex, width: 5, height: 15, borderRadius: 5, float: 'left' }}></div>
          <Typography variant='inherit' noWrap style={{ marginLeft: 5 }}>{option.title ? option.title : option.name}</Typography>
        </li>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...chipProps } = getTagProps({ index });
          return (
            <Chip
              key={option.id}
              {...chipProps}
              label={option.title ? option.title : option.name}
              size="small"
              sx={{
                borderLeft: `4px solid ${option.colorhex || 'transparent'}`,
                borderRadius: '4px',
              }}
            />
          );
        })
      }
      renderInput={params => (
        <TextField {...params} label={label} variant="outlined" required={required} fullWidth />
      )}
    />
  );
}

SimpleAutoCompleteMultipleWithColorStatus.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  stateName: PropTypes.string,
  changeSelect: PropTypes.func,
  selected: PropTypes.array,
  disabled: PropTypes.bool,
};
